import React, { useCallback } from "react";

import { showErrorToast, showSuccessToast } from "../../../components/Toast";

const ShareButton = ({ title, onShared }) => {
  const share = useCallback(async () => {
    const url = window.location.href;

    try {
      if (navigator.share) {
        await navigator.share({ title, url });
        onShared?.();

        return;
      }

      await navigator.clipboard.writeText(url);

      showSuccessToast("Link copied to your clipboard");
      onShared?.();
    } catch (error) {
      if (error?.name === "AbortError") return;

      showErrorToast("Could not share this link.");
    }
  }, [title, onShared]);

  return (
    <button
      type="button"
      className="sy-share"
      onClick={share}
      aria-label={`Share ${title}`}
    >
      <svg viewBox="0 0 20 20" aria-hidden="true">
        <path d="M10 2.5v10M6.5 6 10 2.5 13.5 6M4 12v4.5a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V12" />
      </svg>
    </button>
  );
};

export default ShareButton;
